export default (route) => (route.match(/:/g) || []).length > 1;
